import React, {useState} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Form, Icon, Input, Button, Select, Card, Breadcrumb, message, Divider, Row, Col} from 'antd';
import userService from "../services/users.service";
import Toolbar from '../commons/Toolbar';


const Option = Select.Option;

const successAddUser = () => {
    message.success('The user info was successfully updated');
};

const errorAddUser = () => {
    message.error('There was an error updating user info');
};

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UserEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: {},
            officeData: [],
            passwordChanged: false,
            newPassword: '',
        }

    }

    componentDidMount() {
        // To disabled submit button at the beginning.

        userService.getUser(this.props.location.state[0]._id).then((data) => {
            this.setState(() => {
                return {userData: data};

            });
            console.log({userData: data});
            console.log('props.location.state[0]: ', this.props.location.state[0]);
        });
        userService.getOffices().then((data) => {
            this.setState(() => {
                return {officeData: data}
            })
        });
        console.log("Props value is:", this.props.location.state);

    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Passwords do not match');
        } else {
            callback();
        }
    };

    renderSelectOptions = (offices) => {
        let options = [];
        for (let o of offices) {
            options.push(<Option key={o._id}>{o.office}, {o.country}, {o.region}</Option>);

        }
        return options;
    };

    submit = () => {
        this.props.form.validateFields((error, user) => {
            console.log("edited user:", user);
            console.log(this.state.userData._id, user);
            if (this.state.passwordChanged) {
                user.password = this.state.newPassword;
                delete user['confirm'];
                delete user['name'];
            }
            else {
                delete user['password'];
                delete user['confirm'];
                delete user['name'];
            }
            console.log('after password Change: ',user);
            userService.editUser(this.state.userData._id, user).then((resp) => {
                if (resp) {
                    successAddUser();
                } else {
                    errorAddUser();
                }
                console.log('the response is: ', resp);
            });

        });

    };

    render() {
        const {getFieldDecorator, getFieldsError, getFieldError, isFieldTouched} = this.props.form;

        // Only show error after a field is touched.
        const firstNameError = isFieldTouched('firstName') && getFieldError('firstName');
        const lastNameError = isFieldTouched('lastName') && getFieldError('lastName');
        const usernameError = isFieldTouched('username') && getFieldError('username');
        const emailError = isFieldTouched('email') && getFieldError('email');
        const passwordError = isFieldTouched('password') && getFieldError('password');
        const confpasswordError = isFieldTouched('confirm') && getFieldError('confirm');
        const officeError = isFieldTouched('officeId') && getFieldError('officeId');
        const roleError = isFieldTouched('role') && getFieldError('role');
        const purviewError = isFieldTouched('purview') && getFieldError('purview');
        const statusError = isFieldTouched('status') && getFieldError('status');

        const formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 14},
        };

        const toolBarItems = [
            {
                title: 'Save',
                icon: 'save',
                disabled: hasErrors(getFieldsError()) || this.state.userExists,
                htmlType: 'submit',
                onClick: () => this.submit(),
            },
            {
                title: 'Return',
                icon: 'arrow-left',
                onClick:()=>this.props.history.push({
                    pathname: '/users'})
            },
        ]

        return (

            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>Edit User</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={24}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>
                <Row>
                    <Card bordered={false} type="inner" title="Personal Information" style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)',}}>
                        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                            <Form.Item label="First Name" hasfeedback validateStatus={firstNameError ? 'error' : ''}
                                       help={firstNameError || ''}>
                                {getFieldDecorator('firstName', {
                                    initialValue: this.state.userData.firstName ? this.state.userData.firstName : '',
                                    rules: [{required: true, message: 'Please input your First Name!'}],
                                })(
                                    <Input
                                        placeholder="First Name"
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="Last Name" validateStatus={lastNameError ? 'error' : ''}
                                       help={lastNameError || ''}>
                                {getFieldDecorator('lastName', {
                                    initialValue: this.state.userData.lastName ? this.state.userData.lastName : '',
                                    rules: [{required: true, message: 'Please input your Last Name!'}],
                                })(
                                    <Input
                                        placeholder="Last Name"
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="E-mail" validateStatus={emailError ? 'error' : ''}
                                       help={emailError || ''}>
                                {getFieldDecorator('email', {
                                    initialValue: this.state.userData.email ? this.state.userData.email : '',
                                    rules: [{type: 'email', message: 'Please input a valid E-mail!'}, {
                                        required: true,
                                        message: 'Please input your E-mail!'
                                    }],
                                })(
                                    <Input
                                        prefix={<Icon type="mail" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                        placeholder="email" autoComplete='new-email'
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="User Name" validateStatus={usernameError ? 'error' : ''}
                                       help={usernameError || ''}>
                                {getFieldDecorator('username', {
                                    initialValue: this.state.userData.username ? this.state.userData.username : '',
                                    rules: [{required: true, message: 'Please input your User Name!'}],
                                })(
                                    <Input
                                        prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                        placeholder="username" disabled
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="Password" validateStatus={passwordError ? 'error' : ''}
                                       help={passwordError || ''}>
                                {getFieldDecorator('password', {
                                    initialValue: '******',
                                    rules: [{required: true, message: 'Please input your password!', min:6, message:'Password  must be at least 6 characters'}],
                                })(
                                    <Input
                                        prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                        type="password"
                                        placeholder="password"
                                        autoComplete='new-password'
                                        onChange={(e) => {
                                            this.state.passwordChanged = true;
                                            this.state.newPassword = e.currentTarget.value;
                                            console.log('value: ',e.currentTarget.value);
                                        }}
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="Confirm your Password" validateStatus={confpasswordError ? 'error' : ''}
                                       help={confpasswordError || ''}>
                                {getFieldDecorator('confirm', {
                                    initialValue: '******',
                                    rules: [{required: true, message: 'Please confirm your password!',min:6, message:'Password  must be at least 6 characters'},
                                        {validator: this.checkPassword,}],
                                })(
                                    <Input
                                        prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                        type="password"
                                        placeholder="password"
                                    />,
                                )}
                            </Form.Item>
                        </Form>
                    </Card>
                </Row>
                <Divider/>
                <Row>
                    <Card bordered={false} type="inner" title="Status and Office Information" style={{marginTop: 16, boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}>
                        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                            <Form.Item label="Office" hasFeedback validateStatus={officeError ? 'error' : ''}
                                       help={officeError || ''}>
                                {getFieldDecorator('officeId', {
                                    initialValue: this.state.userData.office ? this.state.userData.office._id : '',
                                    rules: [{required: true, message: 'Please select your Office'}],
                                })(
                                    <Select placeholder="Please select a country">
                                        {this.renderSelectOptions(this.state.officeData)}
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Role" validateStatus={roleError ? 'error' : ''}
                                       help={roleError || ''} hasFeedback>
                                {getFieldDecorator('role', {
                                    initialValue: this.state.userData.role ? this.state.userData.role : '',
                                    rules: [{required: true, message: 'Please select your role'}],
                                })(
                                    <Select placeholder="Please select your role">
                                        <Option value="Data Entry">General User</Option>
                                        <Option value="Supervisor">Supervisor</Option>
                                        <Option value="Administrator">Manager</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Purview" validateStatus={purviewError ? 'error' : ''}
                                       help={purviewError || ''} hasFeedback>
                                {getFieldDecorator('purview', {
                                    initialValue: this.state.userData.purview ? this.state.userData.purview : '',
                                    rules: [{required: true, message: 'Please select purview'}],
                                })(
                                    <Select placeholder="Please select purview">
                                        <Option value="User">Local</Option>
                                        <Option value="Office">Office</Option>
                                        <Option value="Country">Country</Option>
                                        <Option value="Region">Region</Option>
                                        <Option value="Organization">Organization</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item label="Status" validateStatus={statusError ? 'error' : ''}
                                       help={statusError || ''} hasFeedback>
                                {getFieldDecorator('status', {
                                    initialValue: this.state.userData.status ? this.state.userData.status : '',
                                    rules: [{required: true, message: 'Please select a Status'}],
                                })(
                                    <Select placeholder="Please select a status">
                                        <Option value="Active">Active</Option>
                                        <Option value="Inactive">Inactive</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                        </Form>
                    </Card>
                </Row>
            </div>
        );
    }
}

const WrappedUserEditForm = Form.create({name: 'userEdit_form'})(UserEditForm);

export default withRouter(WrappedUserEditForm)